import { apiHigienizacaoJWT } from "api/api-higienizacao";
import { PipelineListItem } from "./types";

export class PipelineListEndpoints {
  public static async getPipelines(
    pageNumber: number = 0,
    pageSize: number = 9
  ): Promise<PipelineListItem[]> {
    const { data } = await apiHigienizacaoJWT.get<PipelineListItem[]>(
      "/higienizacao-pipeline/pipeline-new",
      { params: { page: pageNumber, page_size: pageSize } }
    );

    return data;
  }
}
